import { useInputPasswordProps } from '../../hooks'
import * as Comp from './input-password-actions.styles'

export const InputPasswordActions = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { size, isActive, inputValue, id, hasError, disabled, readonly } =
    useInputPasswordProps()
  const isFilled = inputValue.length > 0

  return (
    <Comp.Actions
      size={size}
      role="form"
      isActive={isActive}
      isFilled={isFilled}
      aria-label={id}
      hasError={hasError}
      disabled={disabled}
      readonly={readonly}
    >
      {children}
    </Comp.Actions>
  )
}
